import { useKey } from 'react-use';
import { useDataSourceRecordStore } from '../stores/DataSourceRecordStore';
import { useGetInterfaceStoreState } from '../stores/InterfaceStore';
import { useGetGlobalStateStoreState, useGlobalStateStore } from '../stores/GlobalStateStore';
import { useInterfaceDrawerStore } from '../stores/InterfaceDrawerStore';
import { useDependencyGraphProvider } from '../context/DependencyGraphContext/DependencyGraphContext';
import { useGetComputeContext } from './computeContext';

export default function useDebugging() {
  const blocksState = useGlobalStateStore().use.blocks();
  const dataSourcesState = useGlobalStateStore().use.dataSources();
  const { getInterfaceStoreState } = useGetInterfaceStoreState();
  const { getGlobalStateStoreState } = useGetGlobalStateStoreState();
  const { getComputeContext } = useGetComputeContext();
  const dataSourceRecord = useDataSourceRecordStore().getState;
  const { graphManager, subscriptionManager } = useDependencyGraphProvider();
  const getInterfaceDrawerStore = useInterfaceDrawerStore().getState;

  const interfaceId = getInterfaceStoreState().interfaceRecord.id;
  const activeInterfacePageId = getInterfaceStoreState().activeInterfacePageId;

  const logHeader = `[Interface: ${interfaceId} | Page: ${activeInterfacePageId}]`;

  useKey(
    'B',
    () => {
      console.group(`${logHeader} Block State`);
      console.log('Blocks:', blocksState);
      console.groupEnd();
    },
    {},
    [blocksState],
  );

  useKey(
    'G',
    () => {
      console.group(`${logHeader} Graph & Subscriptions`);
      console.log('Graph Manager:', graphManager);
      console.log('Subscription Manager:', subscriptionManager);
      console.groupEnd();
    },
    {},
    [dataSourcesState],
  );

  useKey(
    'D',
    () => {
      console.group(`${logHeader} Data Sources`);
      console.log('Data Sources State:', dataSourcesState);
      console.groupEnd();
    },
    {},
    [dataSourcesState],
  );

  useKey(
    'C',
    () => {
      console.group(`${logHeader} Compute Context`);
      console.log('Context:', getComputeContext());
      console.groupEnd();
    },
    {},
    [getComputeContext],
  );

  useKey(
    'I',
    () => {
      console.group(`${logHeader} Interface Store`);
      console.log('Interface Store State:', getInterfaceStoreState());
      console.groupEnd();
    },
    {},
    [getInterfaceStoreState],
  );

  useKey(
    'S',
    () => {
      console.group(`${logHeader} Global State`);
      console.log('Global State:', getGlobalStateStoreState());
      console.log('Interface Store:', getInterfaceStoreState());
      console.log('Data Source Record:', dataSourceRecord());
      console.groupEnd();
    },
    {},
    [getGlobalStateStoreState, getInterfaceStoreState],
  );

  useKey(
    'R',
    () => {
      console.group(`${logHeader} Drawer Store`);
      console.log('Drawer Store:', getInterfaceDrawerStore());
      console.groupEnd();
    },
    {},
    [getInterfaceDrawerStore],
  );
}
